"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m17.73 9.01-1.53-.14-.25-1.52C15.63 5.44 13.94 4 12 4c-1.44 0-2.77.78-3.48 2.04l-.49.87-.99.13C5.31 7.27 4 8.76 4 10.5 4 12.43 5.57 14 7.5 14h10c1.38 0 2.5-1.12 2.5-2.5 0-1.28-.99-2.37-2.27-2.49",
  opacity: ".3"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5 0-2.34-1.79-4.27-4.08-4.48M17.5 14h-10C5.57 14 4 12.43 4 10.5c0-1.74 1.31-3.23 3.04-3.46l.99-.13.49-.87C9.23 4.78 10.56 4 12 4c1.94 0 3.63 1.44 3.95 3.35l.25 1.52 1.54.14c1.27.12 2.26 1.21 2.26 2.49 0 1.38-1.12 2.5-2.5 2.5m-2.7 3-2.9 3.32 2 1L11.55 24h2.65l2.9-3.32-2-1L17.45 17zm-6 0-2.9 3.32 2 1L5.55 24H8.2l2.9-3.32-2-1L11.45 17z"
}, "1")], 'ThunderstormTwoTone');